"use client";

import React, { Fragment, useEffect } from "react";

import { notFound } from "next/navigation";
import useProtocolColor from "@/hooks/data/useProtocolColor";
import useProtocol from "@/hooks/api/useProtocol";
import { SupAlertBar } from "@repo/core-ui";
import { SupAlert } from "@repo/core-ui";

import ProtocolFeaturedVaults from "@/components/Protocol/FeaturedVaults";
import LoaderInPage from "@/components/Loader/InPage";
import UiDetailsAbout from "@/components/Ui/Details/About";
import { hexToRGBA } from "@/utils";
import Table from "@/components/Protocol/About/Table/Table";
import ProductChart from "@/components/Protocol/ProductChart";

export default function SingleProtocolPage({ params: { slug } }: { params: { slug: string } }) {
  const { data: singleProtocol, isLoading, isError } = useProtocol(slug);

  useEffect(() => {
    if (!isLoading && isError) {
      notFound();
    }
  }, [isError, isLoading]);

  const colors = useProtocolColor(singleProtocol, "#C3BBEC");

  return (
    <article>
      {isLoading ? (
        <LoaderInPage />
      ) : (
        singleProtocol && (
          <Fragment>
            <SupAlertBar
              closeable
              visible={Boolean(singleProtocol.status_message)}
              icon={<SupAlert />}
              title="Protocol status"
              content={singleProtocol.status_message}
              className="m-4 md:mx-6"
              style={colors.isCustomColor ? { backgroundColor: hexToRGBA(colors.color, 0.08), color: colors.color } : undefined}
            />

            <UiDetailsAbout
              aboutText={singleProtocol.description}
              colors={colors}
              chart={<ProductChart protocolId={singleProtocol.id} name={singleProtocol.name} />}
              table={<Table metadata={singleProtocol} />}
            />
            <ProtocolFeaturedVaults singleProtocol={singleProtocol} isLoadingProtocol={isLoading} />
          </Fragment>
        )
      )}
    </article>
  );
}
